import { render, staticRenderFns } from "./LiveChatMp4Tree.vue?vue&type=template&id=37bb6951&"
import script from "./LiveChatMp4Tree.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4Tree.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4Tree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports